import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef, useRef, useMemo, useEffect, useImperativeHandle } from 'react';
import { useStyles, StyleSheet, text, icon, border, padding, margin, focus } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { omit, omitBy } from 'lodash';
var fakeUuid = 0;

function uuid() {
  // NOTE: during tests we want to use deterministic uuids, so that
  // snapshot testing can still be useful!
  return process.env.NODE_ENV === 'test' ? ++fakeUuid : // TODO: Fix type - typescript does not like this
  // @ts-ignore
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (a) {
    return (a ^ Math.random() * 16 >> a / 4).toString(16);
  });
}

function DefaultInput(inputProps) {
  return /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement("input", inputProps));
}

var keyboards = {
  number: {
    type: 'number',
    pattern: '[0-9]+([,.][0-9]+)?',
    step: '0.01'
  }
};
var defaultStyles = StyleSheet({
  wrapper: {
    width: function width(_ref) {
      var token = _ref.token;
      return token('textInput.width');
    }
  },
  container: _objectSpread(_objectSpread(_objectSpread({}, border.styles({
    target: 'textInput',
    all: {
      width: 'thin',
      radius: 'small',
      color: 'input.idle'
    }
  })), padding.styles({
    target: 'textInput',
    all: 'xs'
  })), {}, {
    width: '100%',
    cursor: function cursor(_ref2) {
      var token = _ref2.token;
      return token('textInput.cursor', 'text');
    },
    height: function height(_ref3) {
      var token = _ref3.token;
      return token('textInput.height', '3.6rem');
    },
    minHeight: function minHeight(_ref4) {
      var token = _ref4.token;
      return token('textInput.minHeight', '3.6rem');
    },
    backgroundColor: function backgroundColor(_ref5) {
      var token = _ref5.token;
      return token('textInput.background.color', token('color.input.idle'));
    },
    '&:hover': _objectSpread({}, border.styles({
      target: 'textInput.hover',
      all: {
        color: 'input.hover'
      }
    })),
    '&:focus-within': _objectSpread(_objectSpread({}, focus.styles({
      target: 'textInput.focus'
    })), border.styles({
      target: 'textInput.focus',
      all: {
        color: 'input.active'
      }
    }))
  }),
  error: _objectSpread(_objectSpread({}, border.styles({
    target: 'textInput.error',
    all: {
      color: 'input.error'
    }
  })), {}, {
    '&:hover': _objectSpread({}, border.styles({
      target: 'textInput.error.hover',
      all: {
        color: 'input.error'
      }
    })),
    '&:focus-within': _objectSpread({}, border.styles({
      target: 'textInput.error.hover',
      all: {
        color: 'input.error'
      }
    }))
  }),
  disabled: _objectSpread(_objectSpread({
    cursor: 'default'
  }, border.styles({
    target: 'textInput.disabled',
    all: {
      width: 'thin',
      radius: 'small',
      color: 'input.disabled'
    }
  })), {}, {
    '&:hover': _objectSpread({}, border.styles({
      target: 'textInput.disabled.hover',
      all: {
        color: 'input.disabled'
      }
    })),
    backgroundColor: function backgroundColor(_ref6) {
      var token = _ref6.token;
      return token('textInput.disabled.background.color', token('color.input.disabled.default'));
    }
  }),
  input: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    display: 'flex',
    background: 'transparent'
  }, text.styles({
    target: 'textInput.input',
    fallback: 'normal.default'
  })), border.styles({
    target: 'textInput.input',
    all: {
      width: 'none'
    }
  })), padding.styles({
    target: 'textInput.input',
    all: 'none'
  })), {}, {
    width: function width(_ref7) {
      var token = _ref7.token;
      return token('textInput.input.width', '100%');
    },
    '&:focus': {
      outline: 'none',
      boxShadow: 'none'
    },
    '&::placeholder': _objectSpread({}, text.styles({
      target: 'textInput.hintText',
      fallback: 'normal.default',
      color: function color(_ref8) {
        var token = _ref8.token;
        return token('color.textStyle.body.hint');
      }
    }))
  }),
  inputDisabled: _objectSpread({}, text.styles({
    target: 'textInput.input.disabled',
    fallback: 'normal.default',
    color: function color(_ref9) {
      var token = _ref9.token;
      return token('color.textStyle.body.hint');
    }
  })),
  prefix: {
    '& > svg:first-child': _objectSpread({}, icon.styles({
      target: 'textInput.prefix',
      size: 's'
    })),
    // Target the first child of the suffix
    // container so that we can pass a Suffix
    // prop that returns null rather than
    // having to pass null as the Suffix
    '& > *:first-child': _objectSpread({}, margin.styles({
      target: 'textInput.prefix',
      right: 'xs'
    }))
  },
  suffix: {
    '& > svg:first-child': _objectSpread({}, icon.styles({
      target: 'textInput.suffix',
      size: 's'
    })),
    // Target the first child of the suffix
    // container so that we can pass a Suffix
    // prop that returns null rather than
    // having to pass null as the Suffix
    '& > *:first-child': _objectSpread({}, margin.styles({
      target: 'textInput.suffix',
      left: 'xs'
    }))
  },
  // Backwards compatibility styles
  charLimit: _objectSpread({}, text.styles({
    target: 'textInput.charLimit',
    fallback: 'normal.default'
  })),
  charLimitReached: _objectSpread({}, text.styles({
    target: 'textInput.charLimit',
    fallback: 'normal.semibold'
  })),
  charLimitExceeded: _objectSpread({}, text.styles({
    target: 'textInput.charLimit.error',
    fallback: 'normal.semibold',
    color: function color(_ref10) {
      var token = _ref10.token;
      return token('color.input.error');
    }
  }))
});
var displayName = 'TextInput';
export var TextInput = /*#__PURE__*/forwardRef(function (_ref11, ref) {
  var _keyboards$type;

  var disabled = _ref11.disabled,
      _ref11$type = _ref11.type,
      type = _ref11$type === void 0 ? 'text' : _ref11$type,
      style = _ref11.style,
      className = _ref11.className,
      id = _ref11.id,
      name = _ref11.name,
      value = _ref11.value,
      _ref11$meta = _ref11.meta;
  _ref11$meta = _ref11$meta === void 0 ? {} : _ref11$meta;

  var error = _ref11$meta.error,
      _ref11$children = _ref11.children,
      children = _ref11$children === void 0 ? DefaultInput : _ref11$children,
      Prefix = _ref11.Prefix,
      Suffix = _ref11.Suffix,
      prefix = _ref11.prefix,
      suffix = _ref11.suffix,
      charLimit = _ref11.charLimit,
      _ref11$isSoftLimit = _ref11.isSoftLimit,
      isSoftLimit = _ref11$isSoftLimit === void 0 ? true : _ref11$isSoftLimit,
      containerProps = _ref11.containerProps,
      debounce = _ref11.debounce,
      valid = _ref11.valid,
      dirty = _ref11.dirty,
      setRef = _ref11.setRef,
      Container = _ref11.Container,
      Input = _ref11.Input,
      Limit = _ref11.Limit,
      props = _objectWithoutProperties(_ref11, ["disabled", "type", "style", "className", "id", "name", "value", "meta", "children", "Prefix", "Suffix", "prefix", "suffix", "charLimit", "isSoftLimit", "containerProps", "debounce", "valid", "dirty", "setRef", "Container", "Input", "Limit"]);

  var s = useStyles(defaultStyles, displayName);
  useEffect(function () {
    var definedProps = _Object$keys(omitBy({
      debounce: debounce,
      valid: valid,
      dirty: dirty,
      setRef: setRef,
      Container: Container,
      Input: Input,
      Limit: Limit
    }, function (prop) {
      return !prop;
    }));

    if (definedProps.length > 0) {
      console.warn("The props \"".concat(definedProps.join(', '), "\" are deprecated - please see the readme for alternatives"));
    }
  }, [debounce, dirty, setRef, valid, Container, Input, Limit]);
  var inputRef = useRef(null);
  var inputUuid = useMemo(function () {
    return uuid();
  }, []); // Remove styling props so we don't accidentally
  // style the default input with the container styles
  // If a user needs custom styling they can use
  // the render prop

  var cleanedProps = omit(props, ['style', 'className']);

  var inputProps = _objectSpread(_objectSpread(_objectSpread({}, s.with('input', {
    inputDisabled: disabled
  })({
    style: style,
    className: className
  })), (_keyboards$type = keyboards[type]) !== null && _keyboards$type !== void 0 ? _keyboards$type : {
    type: type
  }), {}, {
    value: value,
    disabled: disabled,
    ref: inputRef,
    id: id !== null && id !== void 0 ? id : inputUuid,
    name: name !== null && name !== void 0 ? name : inputUuid,
    autoComplete: inputUuid,
    // Backwards compatibility props
    maxLength: isSoftLimit ? undefined : charLimit
  }, cleanedProps);

  var handleContainerClick = React.useCallback(function (e) {
    var _containerProps$onCli;

    if (inputRef && document.activeElement !== inputRef.current) {
      var _inputRef$current;

      inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }

    containerProps === null || containerProps === void 0 ? void 0 : (_containerProps$onCli = containerProps.onClick) === null || _containerProps$onCli === void 0 ? void 0 : _containerProps$onCli.call(containerProps, e);
  }, [containerProps]);
  var charLength = value === null || value === void 0 ? void 0 : value.length;
  useImperativeHandle(ref, function () {
    return inputRef.current;
  }, []);
  return (
    /*#__PURE__*/
    // TODO: Fix types
    // @ts-ignore
    React.createElement(Box, _extends({
      flexDirection: "column"
    }, s.with('wrapper')(props)), /*#__PURE__*/React.createElement(Box, _extends({}, s('container', {
      error: !!error,
      disabled: disabled
    }), containerProps, {
      alignItems: "center",
      justifyContent: "space-between",
      onClick: handleContainerClick
    }), (prefix || Prefix) && /*#__PURE__*/React.createElement(Box, _extends({}, s('prefix'), {
      flex: 0,
      alignItems: "center"
    }), prefix !== null && prefix !== void 0 ? prefix : /*#__PURE__*/React.createElement(Prefix, null)), children(inputProps), (suffix || Suffix) && /*#__PURE__*/React.createElement(Box, _extends({}, s('suffix'), {
      flex: 0,
      alignItems: "center"
    }), suffix !== null && suffix !== void 0 ? suffix : /*#__PURE__*/React.createElement(Suffix, null))), !!charLimit && /*#__PURE__*/React.createElement(Box, _extends({}, s('charLimit'), {
      alignSelf: "flex-end"
    }), /*#__PURE__*/React.createElement("span", s({
      charLimitReached: charLength >= charLimit,
      charLimitExceeded: charLength > charLimit
    }), charLength !== null && charLength !== void 0 ? charLength : 0), /*#__PURE__*/React.createElement("span", null, "/"), /*#__PURE__*/React.createElement("span", null, charLimit)))
  );
});
TextInput.displayName = displayName;
export default TextInput;